import React from 'react';
interface Props {
  fillColor?: string;
}
function GynaecologyIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none">
      <g clipPath="url(#clip0_847_3060)">
        <path
          d="M2 5.85547C2 4.7946 2.42143 3.77719 3.17157 3.02704C3.92172 2.2769 4.93913 1.85547 6 1.85547C7.06087 1.85547 8.07828 2.2769 8.82843 3.02704C9.57857 3.77719 10 4.7946 10 5.85547C10 6.91633 9.57857 7.93375 8.82843 8.6839C8.07828 9.43404 7.06087 9.85547 6 9.85547C4.93913 9.85547 3.92172 9.43404 3.17157 8.6839C2.42143 7.93375 2 6.91633 2 5.85547ZM6.75 11.3055C9.43125 10.9398 11.5 8.63984 11.5 5.85547C11.5 2.81797 9.0375 0.355469 6 0.355469C2.9625 0.355469 0.5 2.81797 0.5 5.85547C0.5 8.63984 2.56875 10.9398 5.25 11.3055V12.8555H3.75C3.33437 12.8555 3 13.1898 3 13.6055C3 14.0211 3.33437 14.3555 3.75 14.3555H5.25V15.6055C5.25 16.0211 5.58437 16.3555 6 16.3555C6.41563 16.3555 6.75 16.0211 6.75 15.6055V14.3555H8.25C8.66562 14.3555 9 14.0211 9 13.6055C9 13.1898 8.66562 12.8555 8.25 12.8555H6.75V11.3055Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_847_3060">
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0 0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GynaecologyIcon;
